import { ChangeEvent, useState } from "react";
import { idLength, pwLength } from "../../../components/common/common";
import CommonInput from "../../../components/common/form/input/CommonInput";

const SignupContainer = () => {

  const idWaringText = "*중복되는 아이디입니다.";
  const pwWarningText = "*비밀번호가 일치하지 않습니다.";

  const [inputData, setInputData] = useState({
    id: '',
    pw: '',
    pwCheck: '',
    userName: '',
    birthDate: '',
    phoneNumber: ''
  });
  const [isDuplicateId, setIsDuplicateId] = useState(true);
  const [isPwMatched, setIsPwMatched] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    let formattedValue = value;
    let regex = /.*/;

    if (name === 'id' || name === 'pw' || name === 'pwCheck') {
      const maxLength = name === 'id' ? idLength : pwLength;
      if (formattedValue.length > maxLength) return;

      if ((name === 'pwCheck' || name === 'pw') && (inputData.pw === formattedValue || inputData.pwCheck === formattedValue)) {
        setIsPwMatched(true);
      } else {
        setIsPwMatched(false);
      }


    } else if (name === 'birthDate') {
      regex = /^[0-9.]*$/;
      if (formattedValue.length > 10) return;
      if (inputData.birthDate.length < formattedValue.length
        && (formattedValue.length === 4 || formattedValue.length === 7)) formattedValue += '.';
      else if (inputData.birthDate.length < formattedValue.length
        && (formattedValue.length === 5 || formattedValue.length === 8)) {
        formattedValue = formattedValue.slice(0, -1) + "." + formattedValue.slice(-1);
      }
    } else if (name === 'phoneNumber') {
      regex = /^[0-9-]*$/;
      if (formattedValue.length > 13) return;
      if (inputData.phoneNumber.length < formattedValue.length
        && (formattedValue.length === 3 || formattedValue.length === 8)) formattedValue += '-';
      else if (inputData.phoneNumber.length < formattedValue.length
        && (formattedValue.length === 4 || formattedValue.length === 9)) {
        formattedValue = formattedValue.slice(0, -1) + "-" + formattedValue.slice(-1);
      }
    }

    if (regex.test(formattedValue)) {
      setInputData(prev => ({ ...prev, [name]: formattedValue }));
    }
  };

  return <div className="w-full h-full flex flex-col items-center">
    <div className="w-[400px] pt-[60px] flex flex-col gap-[36px]">
      <p className="text-[22px] leading-[22px] font-bold">회원가입</p>
      <div className="w-full h-[80%] flex flex-col justify-center items-center gap-[24px]">
        <CommonInput value={inputData.id} onChange={handleChange} label="아이디" name="id" maxLength={idLength} warningText={isDuplicateId ? idWaringText : undefined} />
        <CommonInput value={inputData.pw} onChange={handleChange} label="비밀번호" name="pw" maxLength={idLength} type="password" />
        <CommonInput value={inputData.pwCheck} onChange={handleChange} label="비밀번호 확인" name="pwCheck" maxLength={idLength} type="password" warningText={!isPwMatched ? pwWarningText : undefined} />
        <CommonInput value={inputData.userName} onChange={handleChange} label="이름" name="name" />
        <CommonInput value={inputData.birthDate} onChange={handleChange} label="생년월일" name="birthDate" placeholder="2000.01.01" />
        <CommonInput value={inputData.phoneNumber} onChange={handleChange} label="전화번호" name="phoneNumber" placeholder="010-1234-5678" />
      </div>
      <button className={`text-white w-full rounded-[8px] bg-blue-dark text-[18px] leading-[18px] py-[18px]`}>
        완료
      </button>
    </div>
  </div>
}

export default SignupContainer;